'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typingMessageReceived = undefined;

var _isFromBot = require('conversations-schema/pubnub-message/operators/isFromBot');

var _isFromVisitor = require('conversations-schema/pubnub-message/operators/isFromVisitor');

var _agentTypingMessageReceived = require('./agentTypingMessageReceived');

var _botTypingMessageReceived = require('./botTypingMessageReceived');

var typingMessageReceived = exports.typingMessageReceived = function typingMessageReceived(message, threadId) {
  return function (dispatch) {
    if ((0, _isFromVisitor.isFromVisitor)(message)) {
      return;
    }

    if ((0, _isFromBot.isFromBot)(message)) {
      dispatch((0, _botTypingMessageReceived.botTypingMessageReceived)(message, threadId));
    } else {
      dispatch((0, _agentTypingMessageReceived.agentTypingMessageReceived)(message, threadId));
    }
  };
};